/* eslint-disable @typescript-eslint/no-explicit-any */
// PageContext.tsx

import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { PageNameType } from '../redux/clientConfiguration/clientConfigurationSlice';
import RoleChecker from '../components/common/RoleChecker';

interface PageContextType {
 pageName: PageNameType;
}

// Create the context with proper types
const PageContext = createContext<PageContextType | undefined>(undefined);

export const PageProvider = ({
 children,
 pageName,
}: {
 children: ReactNode;
 pageName: PageNameType;
}) => {
 // Memoize the value for the context provider
 const contextValue = useMemo(
  () => ({
   pageName,
  }),
  [pageName],
 );

 return (
  <PageContext.Provider value={contextValue}>
   <RoleChecker resource={pageName} action="GetAll">{children}</RoleChecker>
  </PageContext.Provider>
 );
};

export const usePage = (): PageContextType => {
 const context = useContext(PageContext);
 if (!context) {
  throw new Error('usePage must be used within a PageProvider');
 }
 return context;
};
